module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-none element-with-heading",
    attrs: {
      "id": "vol-1-uncategorized"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_vm._v("ACKNOWLEDGEMENTS AND GRATITUDE")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-1-uncategorized-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("All praise is due to the Creator first and foremost. A special love and respect to my guardian angels, ancestors, teachers and guides.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("To my spiritual mothers: Sandy Spears and Bettye Mason Odom; to my son, Jeremy “J. L.” Woodson, who is awesome in every sense of the word.  I love you more than words can ever say.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("To the people who continuously inspire me: Renee Sesvalah Cobb-Dishman, Debra J. Mitchell, Ehryck F. Gilmore, Janine A. Ingram, Jamyi Joy; the members of NK’s Tribe Called Success: Anita L. Roseboro, MarZe Scott, Kisha Green, Terri Johnson, Shannan Harper, Priscilla Jackson, J. D. Mason, Christine Pauls, London St. Charles, J. L. Campbell, Shakir Rashaan, Pat G’Orge-Walker, J. L. Woodson, Michelle D. Rayford, Lisa Dodson, Janice M. Allen, Martha Kennerson, Karen D. Bradley, Sierra Kay, S. L. Jennings, Mo Sytsma, Debra J. Mitchell, Brynn Weimer, Margaret “Bunny” Ervin, and Royce Slade Morton.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Kelly Peterson of InScribe Digital; to the book clubs and avid readers who support my work—much love and respect.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Thank you to the following people for lending an expert editorial touch: Janice M. Allen, Brynn Weimer, to my beautiful Betas: Debra J. Mitchell.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("To J. L. Woodson of Woodson Creative Studio, this cover is everything!!!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("To the members of C.V.S. Class of 1984 who have supported my literary career and other endeavors.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("To everyone I mentioned (and those that I may have forgotten to type), thank you for everything you are to me.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Wishing you all—peace and love, light and joy.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("—Naleighna Kai")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c275e82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol001acknowledgementsandgratitude.vue
// module id = 72
// module chunks = 0